module.exports = __webpack_public_path__ + "static/img/ft-bg.2fdb677.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ft-bg.png
// module id = 6GxF
// module chunks = 1